__turbopack_context__.v({
  "categoryListContainer": "B3JrRq_categoryListContainer",
  "categoryListFooter": "B3JrRq_categoryListFooter",
  "categoryListItemsContainer__largeList": "B3JrRq_categoryListItemsContainer__largeList",
  "categoryListItemsContainer__smallList": "B3JrRq_categoryListItemsContainer__smallList" + " " + "B3JrRq_categoryListItemsContainer__largeList",
  "categoryListLink": "B3JrRq_categoryListLink",
  "categoryListTitle": "B3JrRq_categoryListTitle",
  "categoryListitem": "B3JrRq_categoryListitem",
});
